<template>
  <div id="palyback"
       @click.self="close"
       v-if="show">
    <div class="palyback-content">
      <div class="title">回放章节选购</div>
      <div class="content">
        <div class="tip">您选择的课程中存在已结束的章节，可以以<span>{{discount}}折</span>优惠购买这些章节的回放，学习完整课程会有更好的学习效果。</div>
        <div style="max-height: 317px;overflow: auto;">
          <div class="class-list"
               v-for="(item, index) in playBackList"
               :key="index">
            <div class="class-title">
              <div class="class-check">
                <i slot="reference"
                   class="fa"
                   :class="checkClass.indexOf(item.goods_id)>-1?'fa-check-square':'fa-square-o'"
                   @click="chosePlayBack(item.goods_id)"></i>
              </div>
              <div>
                <h3>{{item.title}}</h3>
                <p>授课老师：{{item.teacher_list}}</p>
              </div>
            </div>
            <div class="class-info">
              <div style="color: #00C7BF;font-weight: 400;">
                回放章节
              </div>
              <div class="class-price">
                <div class="real-price">¥{{item.real_price|handleCountPrice}}</div>
                <div class="original-price">¥{{item.original_price|handleCountPrice}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="total">
          <div>
            <i slot="reference"
               class="fa"
               :class="checkClass.length===playBackList.length?'fa-check-square':'fa-square-o'"
               @click="chosePlayBack()"></i><span style="margin-left:12px;">全选</span>
          </div>
          <div class="warn">
            回放课程有效期为一年，在此期间您可以无限次观看课程视频
          </div>
        </div>
      </div>
      <div class="pay-btn">
        <div class="btn pay"
             @click="toPay">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'

export default {
  props: {
    classList: Array
  },
  data () {
    return {
      discount: 0,
      dialogTableVisible: true,
      checkClass: [],
      show: false,
      allPlayBackClass: [] // 存取购物车存在面授课全部结束和面授课进行中的课下单，单独存全部面授课结束的goods_id
    }
  },
  filters: {
    handleCountPrice (e) {
      let price = e
      if (String(price).indexOf('.') > -1) {
        price = price.toFixed(2)
      }
      return price
    }
  },
  watch: {
    classList () {
      this.checkClass = []
      this.classList.forEach(item => {
        if (item && item.is_buyPlayback) {
          this.checkClass.push(item.goods_id)
        }
      })
    }
  },
  computed: {
    playBackList () {
      return this.classList.filter(item => item && item.is_buyPlayback)
    }
  },
  methods: {
    chosePlayBack (id) {
      if (this.checkClass.length === this.playBackList.length && !id) {
        this.checkClass = []
        return
      } else if (this.checkClass.length !== this.playBackList.length && !id) {
        const arr = this.playBackList.map((item) => {
          return item.goods_id
        })
        this.checkClass = arr
        return
      }
      if (this.checkClass.indexOf(id) > -1) {
        this.checkClass.splice(this.checkClass.indexOf(id), 1)
      } else {
        this.checkClass.push(id)
      }
    },
    close () {
      this.show = false
    },
    toPay () {
      var list = [...this.checkClass, ...this.allPlayBackClass]
      // console.log('list', [...this.checkClass])
      list.forEach((item, index) => {
        list[index] = Number(item)
      })
      this.show = false
      this.$parent.jumpConfirmPage((list).join(','))
      this.zhuGeEventTrack(this.zhugeEvents.CLICK_ENROLLMENT_BUTTON, [
        '回放章节选购页',
        '确定'
      ])
    },
    getReplayDiscount () {
      api
        .getOfflineReplayDiscount().then(res => {
          if (res.data.code === 1) {
            this.discount = res.data.data.limit_number / 10
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#palyback {
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 104;
  left: 0;
  top: 0;
  .palyback-content {
    width: 46.82%;
    background: white;
    border-radius: 4px 4px 4px 4px;
    .title {
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      box-sizing: border-box;
      padding: 14px 0px 16px;
      background: url("../assets/img/class/playback-top.png") center no-repeat;
      background-size: 100% 100%;
    }
    .pay-btn {
      margin-top: 28px;
      display: flex;
      justify-content: flex-end;
      box-sizing: border-box;
      padding: 0px 40px 29px 40px;
      .btn {
        box-sizing: border-box;
        padding: 12px 16px 12px 16px;
        border-radius: 4px;
        border: 1px solid rgba(51, 51, 51, 0.1);
        color: rgba(51, 51, 51, 0.8);
        text-align: center;
        border-radius: 4px;
        cursor: pointer;
      }
      .pay {
        background: linear-gradient(308deg, #38d3cd 0%, #00c7bf 100%);
        color: #ffffff;
        border: 1px solid rgba(51, 51, 51, 0);
        margin-left: 20px;
        padding: 12px 48px;
      }
    }
    .content {
      box-sizing: border-box;
      padding: 20px 40px 0px 40px;
      .tip {
        padding: 11px 19px 18px 16px;
        background: rgba(255, 160, 0, 0.1);
        font-size: 16px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.6);
        line-height: 22px;
        span {
          font-weight: 500;
          color: #ffa000;
        }
      }
      .total {
        box-sizing: border-box;
        padding: 24px 32px 14px 14px;
        margin-top: 12px;
        background: rgba(51, 51, 51, 0.03);
        border-radius: 0px 0px 4px 4px;
        display: flex;
        justify-content: space-between;
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        .warn {
          font-size: 13px;
          font-weight: 400;
          color: rgba(51, 51, 51, 0.6);
          line-height: 23px;
        }
        .fa-check-square:before {
          color: rgb(0, 199, 191);
        }
      }
      .class-list {
        margin-top: 14px;
        border-radius: 2px;
        border: 1px solid rgba(51, 51, 51, 0.1);
        box-sizing: border-box;
        padding: 36px 16px 35px 16px;
        display: flex;
        .class-title,
        .class-info {
          display: flex;
          flex: 1;
          justify-content: space-around;
          .class-check {
            display: flex;
            align-items: center;
            margin-right: 12px;
            .fa-check-square:before {
              color: rgb(0, 199, 191);
            }
          }
          h3,
          p {
            width: 397px;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            -webkit-text-overflow: ellipsis;
            -moz-text-overflow: ellipsis;
            white-space: nowrap;
          }
          p {
            color: rgba(51, 51, 51, 0.6);
          }
          .class-price {
            .real-price {
              margin-bottom: 8px;
              font-weight: 500;
            }
            .original-price {
              text-decoration: line-through;
              font-size: 14px;
              color: rgba(51, 51, 51, 0.3);
            }
          }
        }
      }
    }
  }
}
@media (min-width: 1024px) {
  #palyback {
    .palyback-content {
      min-width: 900px;
    }
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  #palyback {
    .palyback-content {
      width: 88.82%;
    }
  }
}
@media (min-width: 300px) and (max-width: 767px) {
  #palyback {
    .palyback-content {
      width: 100%;
      height: 434px;
      position: fixed;
      bottom: 0px;
      .title {
        font-size: 15px;
      }
      .content {
        padding: 20px 17px 60px 16px;
        height: 374px;
        overflow: auto;
        .tip {
          font-size: 13px;
        }
        .total {
          display: inline-block;
          font-size: 14px;
          padding: 12px;
        }
        .class-list {
          width: 100%;
          display: inline-block;
          justify-content: normal;
          padding: 12px 16px 12px 16px;
          .class-title,
          .class-info {
            h3,
            p {
              width: 250px;
              letter-spacing: 0;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2; /*要显示的行数*/
              -webkit-box-orient: vertical;
              white-space: initial;
            }
            .class-price {
              display: flex;
              flex-direction: row-reverse;
              .original-price {
                font-size: 12px;
                margin-right: 8px;
                line-height: 19px;
              }
              .real-price {
                margin-bottom: 0px;
              }
            }
          }
          .class-info {
            margin-top: 20px;
          }
        }
      }
      .pay-btn {
        position: fixed;
        bottom: 0px;
        background: white;
        width: 100%;
        border-top: 1px solid rgba(51, 51, 51, 0.1);
        padding: 8px 16px 8px 0px;
      }
    }
  }
}
</style>
